import cookies from 'vue-cookies'

const mutations = {
    setUser(state, userData) {
        ////console.log('setUser', userData)
        state.userInfo = userData;
        state.user_id = userData.user_id;
        state.isAdmin = userData.admin === true || userData.admin === 1;
        state.referentialDisplay = userData?.referential;
    },
    setToken(state, token) {
        state.token = token;
        if (token) {
            cookies.set('token', token);
        } else {
            cookies.remove('token');
        }
    },
    setAuthenticated(state, value) {
        state.isAuthenticated = value;
    },
    setStatusResponse(state,value){
        state.respStatus = value
    },
    clearAuth(state) {
        state.userInfo = [];
        state.token = null;
        state.isAuthenticated = false;
        state.isAdmin = false;
        state.referentialDisplay = false;
        state.user_id=0,
        state.emailAnswer=[],
        state.emailState=[],
        state.respStatus= 0,
        state.loading=false,
        state.tempToken=[],
        cookies.remove('token');
    },
    setUserInfo(state, payload){
        state.userInfo = payload;
    },
    fetchEmailAnswer(state, payload){
        state.emailAnswer = payload
    },
    fetchEmailStatuts(state, payload){
        state.emailState = payload
    },
    setTempToken(state,payload){
        //console.log("setTempToken : ", payload)
        state.tempToken = payload
    },
    /* ,
    setRoles(state, roles) {
        state.roles = roles;
    } */
}

export default mutations